
import React, { Component } from 'react';
import { FormControl, Select, MenuItem, InputLabel} from '@mui/material';
import moment from 'moment';

var months = [{name: 'January', value: 1},{name: 'February', value: 2},{name: 'March', value: 3},
{name: 'April', value: 4},{name: 'May', value: 5},{name: 'June', value: 6},
{name: 'July', value: 7},{name: 'August', value: 8},{name: 'September', value: 9},
{name: 'October', value: 10},{name: 'November', value: 11},{name: 'December', value: 12},]

class DateOfBirth extends Component{
    constructor(props){
        super(props)
        this.state = {
            invalidAnswer: true, //on ComponenetDidMount, put logic in to update htis based on response
            answer: "",
            valMin: "",
            valMax: "",
            valPrecision: "",
            errorMessage: "",
            year: -1,
            month: -1,
            day: -1,
            daySelect: null,
            monthSelect: null,
            yearSelect: null,
            inputError: false
        }
    }

    
    componentDidMount() {
        //gotta convert to int for all the math stuff
        //important for comparisons ( >0 vs .length)

        var days = optionGenerator(1, 31, "ASC")
        var year = optionGenerator(2020, 1900, 'DESC')

        this.setState({
            invalidAnswer: true,
            valMin: this.props.question.ValueLimitationMin,
            valMax: this.props.question.ValueLimitationMax,
            valPrecision: this.props.question.ValueLimitationPrecision,
            daySelect: days,
            yearSelect: year
        })

        if(this.props.question.Responses[0].Response.length){
            var date = moment(this.props.question.Responses[0].Response, 'M-D-YYYY').toDate()
            if(!isNaN(date.getDate())){
                this.setState({
                    day: date.getDate(),
                    month: date.getMonth() + 1,
                    year: date.getFullYear()
                })
            }
        }
    }

    setDay = ev => {
        this.setState({
            day: ev.target.value
        }, () =>  {
            if(this.state.day > 0 && this.state.month >= 0  && this.state.year >= 0){
                this.setSavableAnswer()
            }
        })
    }

    setMonth = ev => {
        var thirtyDays = [4, 6, 9, 11]
        var days = this.state.daySelect
        //February
        if(ev.target.value == 2){
            if(this.state.year > -1 && (this.state.year%4 == 0)){
                days = optionGenerator(1, 29, "ASC")
            } else {
                days = optionGenerator(1, 28, "ASC")
            }
            
        }
        //30 Day months 
        if(thirtyDays.includes(ev.target.value)){
            days = optionGenerator(1, 30, "ASC")
        }
        this.setState({
            month: ev.target.value,
            daySelect: days
        }, () =>  {
            if(this.state.day > 0 && this.state.month >= 0  && this.state.year >= 0){
                this.setSavableAnswer()
            }
        })
    }

    setYear = ev => {
        var days = this.state.daySelect
        if((ev.target.value%4) == 0 && this.state.month == 2){
            days = optionGenerator(1, 29, "ASC")
        }
        this.setState({
            year: ev.target.value,
            daySelect: days
        }, () =>  {
            if(this.state.day > 0 && this.state.month >= 0  && this.state.year >= 0){
                this.setSavableAnswer()
            }
        })
    }

    setSavableAnswer() {
        var fullDate = "" + this.state.month + "-" + this.state.day + "-" + this.state.year
        var birthDate = moment("" + this.state.month + "-" + this.state.day + "-" + this.state.year, 'MM-DD-YYYY').toDate()
        var today = new Date()
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age = age - 1;
        }
        
        if(isNaN(birthDate.getDate())){
            this.setState({
                errorMessage: "Invalid Date"
            })
        } 
        //if child's age range
        else if(age < this.props.question.ValueLimitationMin){
            this.setState({
                errorMessage: this.props.validation.InvalidAgeTooYoung.replace("<number>",this.props.question.ValueLimitationMin)
            })
        } 
        //if adult age range
        else if(age > this.props.question.ValueLimitationMax){
            this.setState({
                errorMessage: this.props.validation.InvalidAgeTooOld.replace("<number>",this.props.question.ValueLimitationMax)
            })
        }
        
        else {
            this.props.updateResponseValue(fullDate)
        }
        //console.log(fullDate)

    }

     

    render(){
        if(this.props){
            let answer = this.props.question.Responses[0].Response;
            
            return(
                //<Radio>Answer</Radio>
                <div style={{width:'100%'}}>
                    <FormControl variant="outlined" style={{minWidth:'100px',
                        margin:'10px 0 10px 0',
                        padding:'5px',
                        width:'134px'}}>
                        <InputLabel>{this.props.prompts.Month}</InputLabel>
                        <Select
                          onChange={this.setMonth}
                          autoWidth='true'
                          labelWidth={50}
                          value={this.state.month}
                        >
                        {months.map(month => <MenuItem value={month.value}>{month.name}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <FormControl variant="outlined" style={{minWidth:'100px',
                        margin:'10px 0 10px 0',
                        padding:'5px'}}>
                        <InputLabel>{this.props.prompts.Day}</InputLabel>
                        <Select
                          onChange={this.setDay}
                          autoWidth='true'
                          labelWidth={50}
                          value={this.state.day}
                        >
                        {this.state.daySelect}
                        </Select>
                    </FormControl>
                    <FormControl variant="outlined" style={{minWidth:'100px',
                        margin:'10px 0 10px 0',
                        padding:'5px'}}>
                        <InputLabel>{this.props.prompts.Year}</InputLabel>
                        <Select
                          onChange={this.setYear}
                          autoWidth='true'
                          labelWidth={50}
                          value={this.state.year}
                        >
                        {this.state.yearSelect}
                        </Select>
                    </FormControl>
                    <p>{this.state.errorMessage}</p>
                </div>
                
            )
        }
        
    }
}

//helps generate an array of Dropdown items within a number range
function optionGenerator(start, end, dir){
    var options = []

    if(dir=="ASC"){
        while (start <= end){
            options.push(<MenuItem value={start}>{start}</MenuItem>)
            start++
        }
    } else{
        while (start >= end){
            options.push(<MenuItem value={start}>{start}</MenuItem>)
            start--
        }
    }
    return options
}



export default DateOfBirth;